import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import './styles/main.scss';
import {QueryClientProvider} from '@tanstack/react-query';
import * as serviceWorker from './serviceWorker';
import {store} from './store/store';
import App from './App';
import {initAppErrorLogger} from './utils/sentry/sentry';
import {queryClient} from './utils/queryClient';

initAppErrorLogger();

ReactDOM.render(
    <Provider store={store}>
        <QueryClientProvider client={queryClient}>
            <App />
        </QueryClientProvider>
    </Provider>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
